INITIAL_SIDBAR_WIDTH = 310
App.OrdersController = Em.Controller.extend
  env: Em.inject.service('environment')
  session: Em.inject.service('session')

  queryParams: ['f']
  f: 'all'
  selectedOrdersCategoryBinding: 'f'


  # ---
  # Сервисы
  # ---
  orderMonitor: Em.inject.service('orderMonitor')

  currentOrdersBinding: 'orderMonitor.currentOrders'
  delayedOrdersBinding: 'orderMonitor.delayedOrders'

  organizationsBinding: 'session.availableOrganizations'
  couriers :      null
  restaurants :   null
  tables :   null

  isModalLoading: false
  isCreateOrderLoading: false

  multipleOrganizations: Em.computed.gt('organizations.length', 1)

  isCreatePopoverOpened: false

  deliveryZonesWatcher: (->
    @get('session').set('noDeliveryZonesWithDelivery', @get('zones').filter((z) => z.get('takeaway')==false).length == 0)
  ).observes('zones')

  courierPositions: null

  resizeActive: false

  map: null
  
  resizeEnabled: (->
    @get('selectedOrdersCategory') in ['current', 'delayed']
  ).property('selectedOrdersCategory')

  sidbarWidth: parseInt(localStorage.getItem('sidbarWidth')) or INITIAL_SIDBAR_WIDTH

  sideBarStyle: (->
    sidbarWidth = if @get('resizeEnabled') then @get('sidbarWidth') else INITIAL_SIDBAR_WIDTH
    Ember.String.htmlSafe("flex-basis: #{sidbarWidth}px")
  ).property('sidbarWidth', 'resizeEnabled')

  resize: (e) ->
    return if e.pageX < INITIAL_SIDBAR_WIDTH
    ctx = e.data.ctx
    ctx.set('sidbarWidth', e.pageX)
    localStorage.setItem('sidbarWidth', e.pageX)

  stopResize: (e) ->
    ctx = e.data.ctx
    ctx.set('resizeActive', false)
    ctx.get('map').invalidateSize()
    Em.$(window).off('mousemove', @resize)

  actions:
    createOrderWithinOrganization: (organization) ->
      return if @get('isCreateOrderLoading')

      @set('isCreateOrderLoading', true)

      order = @store.createRecord 'order',
        organization: organization,
        source: 'board'

      order.save()
      .then =>
        order.fillDefaultCity()
      .then =>
        @send('showOrderModal',    order)
        @send('appendOrderToList', order)
      .finally =>
        @set('isCreateOrderLoading', false)
        @set('isCreatePopoverOpened', false)

      false

    createOrder: ->
      # Если одна организация, то сразу создаем заказ в ней
      if !@get('multipleOrganizations')
        organization = @get('organizations.firstObject')
        @send('createOrderWithinOrganization', organization)

      false

    openOrder: (order) ->
      if order
        @transitionToRoute 'orders.map.order.detailed', order
      else
        @transitionToRoute 'orders.map'
      false

    openTimePopup: (order) ->
      @set('popupOrder', order)
      @get('miniPopups').send('openPopup', 'time-popup')
      false

    openStatusPopup: (order) ->
      @set('popupOrder', order)
      @get('miniPopups').send('openPopup', 'status-popup')
      false

    openCourierPopup: (order) ->
      @set('popupOrder', order)
      @get('miniPopups').send('openPopup', 'courier-popup')
      false

    resizeBlock: () ->
      @set('resizeActive', true)
      Em.$(window).on('mousemove',{
        ctx: @
      }, @resize)
      Em.$(window).on('mouseup',{
        ctx: @
      }, @stopResize)

    mapRegistred: (map) ->
      @set('map', map)
